"use client";

import { useState } from "react";
import { Menu } from "lucide-react";
import { UsageSidebar } from "./usage-sidebar";

export function MobileMenu({ phone }: { phone: string }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="rounded-md p-1.5 text-[#545557] hover:bg-[#f5f5f5]"
        aria-label="打开菜单"
      >
        <Menu className="h-5 w-5" />
      </button>
      {open && (
        <div className="fixed inset-0 z-50 md:hidden" role="dialog" aria-modal="true">
          <div className="absolute inset-0 bg-[#212327]/40" onClick={() => setOpen(false)} />
          <div className="absolute inset-y-0 left-0 w-64 shadow-2xl">
            <UsageSidebar phone={phone} onClose={() => setOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
}
